<template>
  <material-card
    :title="$t('views.pendinghourstaskstable.pending_hours_tasks')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="schedule"
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <pbas-data-table
      ref="table"
      :exporters="$exporters"
      :dataProvider="provider"
      :showSelect="false"
      :rowActions="rowActions"
      fileNamePrefix="pending-hours-tasks"
      identifier="pendingHourTasks"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="deleteDialog" persistent max-width="500">
      <material-card
        v-if="item"
        :title="$t('views.pendinghourstaskstable.delete_dialog_title')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false" :loading="saving">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete" :loading="saving">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";
import PendingHoursTasksHeaders from "../headers/PendingHoursTasks";

export default {
  components: {
    ErrorHandler,
  },
  mixins: [planSetter],
  data() {
    return {
      loading: false,
      item: null,
      provider: undefined,
      deleteDialog: false,
      error: null,
      rowActions: [
        {
          name: "continue",
          icon: "work",
          title: "views.members.manage",
          handler: (item) => {
            this.$router.push({
              name: "hoursImportWizardWithId",
              params: {
                planId: this.selectedPlan.Id,
                pendingImportId: item.TaskIdentifier,
              },
            });
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.item = item;
            this.deleteDialog = true;
          },
        },
      ],
      saving: false,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["deletePendingHoursTask"]),
    loadPlanData() {
      this.provider = new ODataProvider(
        this.$axiosHttp,
        "plans/" +
          this.selectedPlan.Id +
          "/pending-imports/pending-hour-reports",
        PendingHoursTasksHeaders
      );
    },
    async tryDelete() {
      try {
        this.saving = true;
        await this.deletePendingHoursTask({
          planIdentityId: this.selectedPlan.Id,
          pendingImportId: this.item.Id,
        });
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.deleteDialog = false;
        this.$refs.table.getDataAsync();
      }
    },
  },
};
</script>
